<style lang="scss" scoped>
@import "/src/styles/scss/_variables.scss";
@import "./prefix.scss";
</style>

<template>
  <div class="prefix" v-if="(hasPrefix && variant !== 'display') || inputType === 'phone'">
    <svg class="icon feather" v-if="hasIcon">
      <use :href="`/imgs/storybook/feather-sprite.svg#${icon}`" />
    </svg>
    <div class="label">
      <span @click="toggleControlList">
        {{ inputType === "phone" ? prefixLabel || `+${selectedPhoneCode}` : prefixLabel }}
        <svg class="control-icon feather">
          <use :href="`/imgs/storybook/feather-sprite.svg#${controlIcon}`" />
        </svg>
      </span>
      <div class="control-list-selection" v-if="isControlListVisible && isScreenSizeAboveBreakpoint">
        <div class="list-item" v-for="(item, index) in phoneCodeList" :key="index" @click="onSelectPhoneCode(item)">
          {{ item.description }}
        </div>
      </div>
      <BottomSheet
        :isVisible="bottomSheetVisible"
        @close="handleBottomSheetClose"
        attached
        noHeader
        drawerHeight="default"
        v-if="isControlListVisible && !isScreenSizeAboveBreakpoint"
      >
        <template #content>
          <div class="control-list-selection-mobile">
            <div class="list-item" v-for="(item, index) in phoneCodeList" :key="index" @click="onSelectPhoneCode(item)">
              {{ item.description }}
            </div>
          </div>
        </template>
      </BottomSheet>
    </div>
  </div>
</template>

<script>
import BottomSheet from "../bottom-sheet/bottomSheetView.vue";

export default {
  name: "PrefixComponent",
  props: {
    hasPrefix: { type: Boolean },
    variant: { type: String },
    inputType: { type: String },
    hasIcon: { type: Boolean },
    icon: { type: String },
    controlIcon: { type: String },
    prefixLabel: { type: String },
    isControlListVisible: { type: Boolean },
    phoneCodeList: { type: Array },
    selectedPhoneCode: { type: String },
  },
  components: { BottomSheet },
  data() {
    return {
      bottomSheetVisible: false,
      isScreenSizeAboveBreakpoint: window.innerWidth > 768, // Adjust breakpoint as needed
    };
  },
  mounted() {
    // Update isScreenSizeAboveBreakpoint on window resize
    window.addEventListener("resize", this.updateScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenSize);
  },
  methods: {
    handleBottomSheetClose() {
      this.bottomSheetVisible = false;
    },
    updateScreenSize() {
      this.isScreenSizeAboveBreakpoint = window.innerWidth > 768; // Adjust breakpoint as needed
    },
    toggleControlList() {
      this.bottomSheetVisible = !this.bottomSheetVisible;
      this.$emit("toggleControlList");
    },
    onSelectPhoneCode(item) {
      this.$emit("onSelectPhoneCode", item);
      this.bottomSheetVisible = false;
    },
  },
};
</script>
